import Vue from 'vue'
import Router from 'vue-router'

const Main = () => import('../components/main')

const Dashboard = () => import('../views/Dashboard')
const Unit = () => import('../views/Unit')
const Itemmanage = () => import('../views/Itemmanage')
const Usersmanage = () => import('../views/Usersmanage')
const ProdSafetyFactorView = () => import('../views/Prodsafetyfactor')
const MrpcalView = () => import('../views/Mrpcal')

const ConfigView = () => import('../views/Config')
const SupplierView = () => import('../views/Supplier')
const DockView = () => import('../views/Dock')

const ReceiveView = () => import('../views/Receive')
const ReceiveorderView = () => import('../views/Receiveorder')
const ReceiveorderconfirmView = () => import('../views/Receiveorderconfirm')
const ReceiveEditView = () => import('../views/Receiveedit')
const ReceiveorderEditView = () => import('../views/Receiveorderedit')
const ReceiveorderListView = () => import('../views/Receiveorderlist')
const ReceiveorderconfirmEditView = () => import('../views/Receiveorderconfirmedit')

const InspectView = () => import('../views/Inspect')
const InspectAddView = () => import('../views/Inspectadd')
const InspectEditView = () => import('../views/Inspectedit')

const AdjustView = () => import('../views/Adjust')
const AdjustAddView = () => import('../views/Adjustadd')

const KanbanAdjustView = () => import('../views/KanbanAdjust')
const KanbanAdjustManageView = () => import('../views/KanbanAdjustManage')

const KanbanAdjustDayoffUploadView = () => import('../views/KanbanAdjustDayoffUpload')
const KanbanAdjustFactorUploadView = () => import('../views/KanbanAdjustFactorUpload')

const LocationlinkView = () => import('../views/Locationlink')
const Permission = () => import('../views/Permission')

const ReportpartlinkageView = () => import('../views/Reportpartlinkage')
const ReportallpartserialView = () => import('../views/Reportallpartserial')
const ReportstocktrackingeView = () => import('../views/Reportstocktracking')
const ReportinspectView = () => import('../views/Reportinspect')
const ReportreceiveView = () => import('../views/Reportreceive')
const ReportreceiveOrderView = () => import('../views/Reportreceiveorder')
const ReportissueView = () => import('../views/Reportissue')
const ReportstockshelftrackingView = () => import('../views/Reportstockshelftracking')
const ReportsummarybypartView = () => import('../views/Reportsummarybypart')
const ReportstockdetailbyshelfView = () => import('../views/Reportstockdetailbyshelf')
const ReportstockhistoryView = () => import('../views/Reportstockhistory')
const ReportadjustView = () => import('../views/Reportadjust')
const ReportkanbanView = () => import('../views/Reportkanban')
const ReportkanbansuffixView = () => import('../views/Reportkanbansuffix')
const ReporttruckmasterView = () => import('../views/Reporttruckmaster')
const ReportmaxminView = () => import('../views/Reportmaxmin')

const LogLoginView = () => import('../views/Loglogin')
const LogConfigView = () => import('../views/Logconfig')
const LogAdjustView = () => import('../views/Logadjust')
const LogCalendarView = () => import('../views/Logcalendar')
const LogDockView = () => import('../views/Logdock')
const LogInspectView = () => import('../views/Loginspect')
const LogIssueView = () => import('../views/Logissue')
const LogLocationLinkageView = () => import('../views/Loglocationlinkage')
const LogPartView = () => import('../views/Logpart')
const LogPartStoreView = () => import('../views/Logpartstore')
const LogReceiveView = () => import('../views/Logreceive')
const LogSupplierView = () => import('../views/Logsupplier')
const LogUserView = () => import('../views/Loguser')
const LogPSFView = () => import('../views/Logpsf')
const LogMRPView = () => import('../views/Logmrp')
const LogKanbanAdjustView = () => import('../views/Logkanbanadjust')

const Login = () => import('../views/Login')
const Waiting = () => import('../components/wait')
const Error404 = () => import('../components/404')

const IssueView = () => import('../views/Issue')
const IssueAddView = () => import('../views/Issueadd')
const IssueEditView = () => import('../views/Issueedit')

const DayoffView = () => import('../views/Dayoff')
const CalendarpatternView = () => import('../views/Calendarpattern')
const TrucktypeView = () => import('../views/Trucktype')
const TruckView = () => import('../views/Truck')
const TruckDetailView = () => import('../views/Truckdetail')
const TruckPatternView = () => import('../views/Truckpattern')
const CyclekView = () => import('../views/Cycle')
const CycleDetailView = () => import('../views/Cycledetail')

const OrderReleaseView = () => import('../views/Orderrelease')
const OrderPlanView = () => import('../views/Orderplan')
const OrderPlanUploadView = () => import('../views/OrderPlanUpload')
const ConfirmOrderView = () => import('../views/Confirmorder')
const OrderDetailView = () => import('../views/Orderdetail')
const DeliveryPlanView = () => import('../views/Deliveryplan')

const SuffixSearchView = () => import('../views/Suffixsearch')
const KanbanSuffixView = () => import('../views/Kanbansuffix')

Vue.use(Router)
const titlename = ' | AGcaddy'

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'wait',
      component: Waiting,
      meta: { title: 'Waiting', title_sub: '', group_id: 0, menu_id: 0 }
    },
    {
      path: '',
      name: 'Main',
      component: Main,
      children: [
        // Dashboard
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: { title: 'Dashboard', title_sub: '', group_id: '1', menu_id: '1' }
        },
        // Master Data
        {
          path: '/supplier',
          name: 'supplier',
          component: SupplierView,
          meta: { title: 'Master Data', title_sub: 'Supplier List', group_id: '2', menu_id: '19' }
        },
        {
          path: '/dock',
          name: 'Dock',
          component: DockView,
          meta: { title: 'Master Data', title_sub: 'Dock List', group_id: '2', menu_id: '20' }
        },
        {
          path: '/unit',
          name: 'Unit',
          component: Unit,
          meta: { title: 'Master Data', title_sub: 'Unit List', group_id: '2', menu_id: '3' }
        },
        {
          path: '/itemmanage',
          name: 'Itemmanage',
          component: Itemmanage,
          meta: { title: 'Master Data', title_sub: 'Part List', group_id: '2', menu_id: '2' }
        },
        {
          path: '/pattern',
          name: 'Pattern',
          component: CalendarpatternView,
          meta: { title: 'Setting', title_sub: 'Pattern', group_id: '6', menu_id: '47' }
        },
        {
          path: '/locationlink',
          name: 'Locationlink',
          component: LocationlinkView,
          meta: { title: 'Master Data', title_sub: 'Shelf Location', group_id: '2', menu_id: '21' }
        },
        {
          path: '/trucktype',
          name: 'Trucktype',
          component: TrucktypeView,
          meta: { title: 'Master Data', title_sub: 'Truck type', group_id: '2', menu_id: '54' }
        },
        // Operation
        {
          path: '/receive',
          name: 'receive',
          component: ReceiveView,
          meta: { title: 'Operation', title_sub: 'Stock In', group_id: '3', menu_id: '4' }
        },
        {
          path: '/receiveorder',
          name: 'receiveorder',
          component: ReceiveorderView,
          meta: { title: 'Operation', title_sub: 'Stock In Order', group_id: '3', menu_id: '60' }
        },
        {
          path: '/receiveorderconfirm',
          name: 'receiveorderconfirm',
          component: ReceiveorderconfirmView,
          meta: { title: 'Operation', title_sub: 'Stock In Confirm', group_id: '3', menu_id: '62' }
        },
        {
          path: '/receiveedit',
          name: 'receive_edit',
          component: ReceiveEditView,
          meta: { title: 'Operation', title_sub: 'Stock In Edit', group_id: '3', menu_id: '4' }
        },
        {
          path: '/receiveorderedit',
          name: 'receiveorder_edit',
          component: ReceiveorderEditView,
          meta: { title: 'Operation', title_sub: 'Stock In Order Edit', group_id: '3', menu_id: '60' }
        },
        {
          path: '/receiveorderconfirmedit',
          name: 'receiveorderconfirm_edit',
          component: ReceiveorderconfirmEditView,
          meta: { title: 'Operation', title_sub: 'Stock In Confirm Edit', group_id: '3', menu_id: '62' }
        },
        {
          path: '/receiveorderlist',
          name: 'receiveorder_list',
          component: ReceiveorderListView,
          meta: { title: 'Operation', title_sub: 'Stock In Order List', group_id: '3', menu_id: '60' }
        },
        {
          path: '/issue',
          name: 'issue',
          component: IssueView,
          meta: { title: 'Operation', title_sub: 'Stock Out', group_id: '3', menu_id: '5' }
        },
        {
          path: '/issueadd',
          name: 'issueadd',
          component: IssueAddView,
          meta: { title: 'Operation', title_sub: 'Add Stock Out', group_id: '3', menu_id: '5' }
        },
        {
          path: '/issueedit',
          name: 'issueedit',
          component: IssueEditView,
          meta: { title: 'Operation', title_sub: 'Edit Stock Out', group_id: '3', menu_id: '5' }
        },
        {
          path: '/inspect',
          name: 'Inspect',
          component: InspectView,
          meta: { title: 'Operation', title_sub: 'Stock Taking', group_id: '3', menu_id: '6' }
        },
        {
          path: '/inspectadd',
          name: 'inspect_add',
          component: InspectAddView,
          meta: { title: 'Operation', title_sub: 'Stock Taking Add', group_id: '3', menu_id: '6' }
        },
        {
          path: '/inspect/:id',
          name: 'inspect_edit',
          component: InspectEditView,
          meta: { title: 'Operation', title_sub: 'Stock Taking Edit', group_id: '3', menu_id: '6' }
        },
        {
          path: '/adjust',
          name: 'Adjust',
          component: AdjustView,
          meta: { title: 'Input', title_sub: 'Adjust Stock', group_id: '4', menu_id: '7' }
        },
        {
          path: '/adjustadd',
          name: 'Adjust_add',
          component: AdjustAddView,
          meta: { title: 'Operation', title_sub: ' Add Adjust Stock', group_id: '3', menu_id: '7' }
        },
        {
          path: '/orderrelease',
          name: 'orderrelease',
          component: OrderReleaseView,
          meta: { title: 'Operation', title_sub: 'Order Release', group_id: '3', menu_id: '53' }
        },
        {
          path: '/orderplan',
          name: 'OrderPlan',
          component: OrderPlanView,
          meta: { title: 'Operation', title_sub: 'Order Plan', group_id: '3', menu_id: '66' }
        },
        {
          path: '/orderplanupload',
          name: 'OrderPlanUpload',
          component: OrderPlanUploadView,
          meta: { title: 'Operation', title_sub: 'Order Plan Upload', group_id: '3', menu_id: '66' }
        },
        {
          path: '/kanbanadjust',
          name: 'KanbanAdjust',
          component: KanbanAdjustView,
          meta: { title: 'Input', title_sub: 'Kanban Adjust', group_id: '4', menu_id: '56' }
        },
        {
          path: '/kanbanadjustmanage/:ps_id',
          name: 'KanbanAdjustManage',
          component: KanbanAdjustManageView,
          meta: { title: 'Operation', title_sub: 'Kanban Adjust Manage', group_id: '4', menu_id: '56' }
        },
        {
          path: '/kanbanadjustdayoffupload',
          name: 'KanbanAdjustDayoffUpload',
          component: KanbanAdjustDayoffUploadView,
          meta: { title: 'Input', title_sub: 'Kanban Adjust Dayoff Upload', group_id: '4', menu_id: '56' }
        },
        {
          path: '/kanbanadjustfactorupload',
          name: 'KanbanAdjustFactorUpload',
          component: KanbanAdjustFactorUploadView,
          meta: { title: 'Input', title_sub: 'Kanban Adjust Factor Upload', group_id: '4', menu_id: '56' }
        },
        {
          path: '/confirmorder',
          name: 'confirmorder',
          component: ConfirmOrderView,
          meta: { title: 'Operation', title_sub: 'Confirmation Order', group_id: '3', menu_id: '55' }
        },
        {
          path: '/orderdetail',
          name: 'orderdetail',
          component: OrderDetailView,
          meta: { title: 'Operation', title_sub: 'Order Detail', group_id: '3', menu_id: '55' }
        },
        {
          path: '/deliveryplan',
          name: 'deliveryplan',
          component: DeliveryPlanView,
          meta: { title: 'Operation', title_sub: 'Delivery Plan', group_id: '3', menu_id: '55' }
        },
        // Input
        {
          path: '/truck',
          name: 'Truck',
          component: TruckView,
          meta: { title: 'Master Data', title_sub: 'Truck Master', group_id: '2', menu_id: '8' }
        },
        {
          path: '/truckdetail',
          name: 'truckdetail',
          component: TruckDetailView,
          meta: { title: 'Input', title_sub: 'Truck Pattern', group_id: '2', menu_id: '8' }
        },
        {
          path: '/truckpattern',
          name: 'truckpattern',
          component: TruckPatternView,
          meta: { title: 'Input', title_sub: 'Truck Calendar', group_id: '2', menu_id: '8' }
        },
        {
          path: '/cycle',
          name: 'cycle',
          component: CyclekView,
          meta: { title: 'Master Data', title_sub: 'Cycle Registration', group_id: '2', menu_id: '28' }
        },
        {
          path: '/cycledetail',
          name: 'cycledetail',
          component: CycleDetailView,
          meta: { title: 'Input', title_sub: 'Cycle Registration', group_id: '2', menu_id: '28' }
        },
        {
          path: '/prodsafetyfactor',
          name: 'prodsafetyfactor',
          component: ProdSafetyFactorView,
          meta: { title: 'Input', title_sub: 'Prod & Safety Factor', group_id: '4', menu_id: '29' }
        },
        {
          path: '/dayoff',
          name: 'Dayoff',
          component: DayoffView,
          meta: { title: 'Master Data', title_sub: 'Calendar', group_id: '2', menu_id: '46' }
        },
        {
          path: '/mrp',
          name: 'mrpcal',
          component: MrpcalView,
          meta: { title: 'Input', title_sub: 'MRP Cal', group_id: '4', menu_id: '30' }
        },
        // Report
        {
          path: '/reportreceive',
          name: 'Reportreceive',
          component: ReportreceiveView,
          meta: { title: 'Report', title_sub: 'Report Stock In', group_id: '5', menu_id: '9' }
        },
        {
          path: '/reportreceiveorder',
          name: 'Reportreceiveorder',
          component: ReportreceiveOrderView,
          meta: { title: 'Report', title_sub: 'Report Stock In Order', group_id: '5', menu_id: '61' }
        },
        {
          path: '/reportissue',
          name: 'Reportissue',
          component: ReportissueView,
          meta: { title: 'Report', title_sub: 'Report Stock Out', group_id: '5', menu_id: '10' }
        },
        {
          path: '/reportinspect',
          name: 'Reportinspect',
          component: ReportinspectView,
          meta: { title: 'Report', title_sub: 'Report Inspect', group_id: '5', menu_id: '11' }
        },
        {
          path: '/reportpartlinkage',
          name: 'Reportpartlinkage',
          component: ReportpartlinkageView,
          meta: { title: 'Report', title_sub: 'Report Part Linkage', group_id: '5', menu_id: '22' }
        },
        {
          path: '/reportallpartserial',
          name: 'Reportallpartserial',
          component: ReportallpartserialView,
          meta: { title: 'Report', title_sub: 'Report Serial', group_id: '5', menu_id: '59' }
        },
        {
          path: '/reportstocktracking',
          name: 'Reportstocktracking',
          component: ReportstocktrackingeView,
          meta: { title: 'Report', title_sub: 'Report Balance Stock', group_id: '5', menu_id: '23' }
        },
        {
          path: '/reportstockshelftracking',
          name: 'Reportstockshelftracking',
          component: ReportstockshelftrackingView,
          meta: { title: 'Report', title_sub: 'Report Balance Stock', group_id: '5', menu_id: '24' }
        },
        {
          path: '/reportstockhistory',
          name: 'Reportstockhistory',
          component: ReportstockhistoryView,
          meta: { title: 'Report', title_sub: 'Report History Stock Taking By Part', group_id: '5', menu_id: '25' }
        },
        {
          path: '/reportsummarybypart',
          name: 'Reportsummarybypart',
          component: ReportsummarybypartView,
          meta: { title: 'Report', title_sub: 'Report Summary By Part', group_id: '5', menu_id: '26' }
        },
        {
          path: '/reportstockdetailbyshelf',
          name: 'Reportstockdetailbyshelf',
          component: ReportstockdetailbyshelfView,
          meta: { title: 'Report', title_sub: 'Report Stock Detail By Shelf', group_id: '5', menu_id: '27' }
        },
        {
          path: '/reporttruckmaster',
          name: 'Reporttruckmaster',
          component: ReporttruckmasterView,
          meta: { title: 'Report', title_sub: 'Report Truck Master', group_id: '5', menu_id: '52' }
        },
        {
          path: '/reportmaxmin',
          name: 'Reportmaxmin',
          component: ReportmaxminView,
          meta: { title: 'Report', title_sub: 'Report Kanban Setup', group_id: '5', menu_id: '32' }
        },
        {
          path: '/reportadjust',
          name: 'Reportadjust',
          component: ReportadjustView,
          meta: { title: 'Report', title_sub: 'Report Adjust', group_id: '5', menu_id: '12' }
        },
        {
          path: '/reportkanban',
          name: 'Reportkanban',
          component: ReportkanbanView,
          meta: { title: 'Report', title_sub: 'Report Kanban Adjust', group_id: '5', menu_id: '57' }
        },
        {
          path: '/reportkanbansuffix',
          name: 'Reportkanbansuffix',
          component: ReportkanbansuffixView,
          meta: { title: 'Report', title_sub: 'Report Kanban Suffix', group_id: '5', menu_id: '65' }
        },
        // Setting
        {
          path: '/config',
          name: 'config',
          component: ConfigView,
          meta: { title: 'Setting', title_sub: 'Company', group_id: '6', menu_id: '14' }
        },
        {
          path: '/users',
          name: 'users',
          component: Usersmanage,
          meta: { title: 'Setting', title_sub: 'Users', group_id: '6', menu_id: '15' }
        },
        {
          path: '/permission',
          name: 'Permission',
          component: Permission,
          meta: { title: 'Setting', title_sub: 'Permission', group_id: '6', menu_id: '16' }
        },
        // Log
        {
          path: '/loglogin',
          name: 'LogLogin',
          component: LogLoginView,
          meta: { title: 'Logs History', title_sub: 'Log Login', group_id: '7', menu_id: '17' }
        },
        {
          path: '/logconfig',
          name: 'LogCompany',
          component: LogConfigView,
          meta: { title: 'Logs History', title_sub: 'Log Company', group_id: '7', menu_id: '18' }
        },

        {
          path: '/loguser',
          name: 'LogUser',
          component: LogUserView,
          meta: { title: 'Logs History', title_sub: 'Log User', group_id: '7', menu_id: '43' }
        },
        {
          path: '/logadjust',
          name: 'LogAdjust',
          component: LogAdjustView,
          meta: { title: 'Logs History', title_sub: 'Log Adjust', group_id: '7', menu_id: '33' }
        },
        {
          path: '/logcalendar',
          name: 'LogCalendar',
          component: LogCalendarView,
          meta: { title: 'Logs History', title_sub: 'Log Calendar', group_id: '7', menu_id: '34' }
        },
        {
          path: '/logdock',
          name: 'LogDock',
          component: LogDockView,
          meta: { title: 'Logs History', title_sub: 'Log Dock', group_id: '7', menu_id: '35' }
        },
        {
          path: '/loginspect',
          name: 'LogInspect',
          component: LogInspectView,
          meta: { title: 'Logs History', title_sub: 'Log Inspect', group_id: '7', menu_id: '36' }
        },
        {
          path: '/logissue',
          name: 'LogIssue',
          component: LogIssueView,
          meta: { title: 'Logs History', title_sub: 'Log Issue', group_id: '7', menu_id: '37' }
        },
        {
          path: '/loglocationlinkage',
          name: 'LogLocationLinkage',
          component: LogLocationLinkageView,
          meta: { title: 'Logs History', title_sub: 'Log Location Linkage', group_id: '7', menu_id: '38' }
        },
        {
          path: '/logpart',
          name: 'LogPart',
          component: LogPartView,
          meta: { title: 'Logs History', title_sub: 'Log Part', group_id: '7', menu_id: '39' }
        },
        {
          path: '/logpartstore',
          name: 'LogPartStore',
          component: LogPartStoreView,
          meta: { title: 'Logs History', title_sub: 'Log Part Store', group_id: '7', menu_id: '40' }
        },
        {
          path: '/logreceive',
          name: 'LogReceive',
          component: LogReceiveView,
          meta: { title: 'Logs History', title_sub: 'Log Receive', group_id: '7', menu_id: '41' }
        },
        {
          path: '/logsupplier',
          name: 'LogSupplier',
          component: LogSupplierView,
          meta: { title: 'Logs History', title_sub: 'Log Supplier', group_id: '7', menu_id: '42' }
        },
        {
          path: '/logpsf',
          name: 'LogPSF',
          component: LogPSFView,
          meta: { title: 'Logs History', title_sub: 'Log Prod & Safety Factor', group_id: '7', menu_id: '50' }
        },
        {
          path: '/logmrp',
          name: 'LogMRP',
          component: LogMRPView,
          meta: { title: 'Logs History', title_sub: 'Log MRP Cal', group_id: '7', menu_id: '51' }
        },
        {
          path: '/logkanbanadjust',
          name: 'LogKanbanAdjust',
          component: LogKanbanAdjustView,
          meta: { title: 'Logs History', title_sub: 'Log Kanban Adjust', group_id: '7', menu_id: '58' }
        },
        {
          path: '/suffixsearch',
          name: 'Suffixsearch',
          component: SuffixSearchView,
          meta: { title: 'Operation', title_sub: 'Kanban Suffix Search', group_id: '3', menu_id: '64' }
        },
        {
          path: '/kanbansuffix',
          name: 'kanbansuffix',
          component: KanbanSuffixView,
          meta: { title: 'Operation', title_sub: 'Kanban Suffix Search', group_id: '3', menu_id: '64' }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { title: 'Login', title_sub: 'Login' }
    },
    {
      path: '*',
      name: 'P404',
      component: Error404,
      meta: { title: 'Error Page', title_sub: 'Error Page' }
    }
  ]
})
const DEFAULT_TITLE = titlename
router.afterEach((to, from) => {
  document.title = to.meta.title_sub !== '' ? to.meta.title_sub + titlename : to.meta.title + titlename || DEFAULT_TITLE + titlename
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js